import { render, staticRenderFns } from "./ipwhitelist.vue?vue&type=template&id=53ce3321&scoped=true&"
import script from "./ipwhitelist.vue?vue&type=script&lang=js&"
export * from "./ipwhitelist.vue?vue&type=script&lang=js&"
import style0 from "./ipwhitelist.vue?vue&type=style&index=0&id=53ce3321&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ce3321",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53ce3321')) {
      api.createRecord('53ce3321', component.options)
    } else {
      api.reload('53ce3321', component.options)
    }
    module.hot.accept("./ipwhitelist.vue?vue&type=template&id=53ce3321&scoped=true&", function () {
      api.rerender('53ce3321', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ugsrc/components/apps/ipwhitelist.vue"
export default component.exports